import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import MoreMechaStore from './store';
import cx from 'classnames';
import Link from '@src/components/link';
import BaseSwiper from '@src/components/swiper/base-swiper';

const styles = require('./index.less');

// 更多机甲
const MoreMecha = ({ store }) => {
  store.use();
  //console.log(store.more_mecha_list);
  const mechaTABSwiper = () => {
    if (store.more_mecha_list?.length === 0) {
      return null;
    }
    return (
      <BaseSwiper store={store.moreMechaSwiper}>
        {store.more_mecha_list?.map((item, key) => {
          return (
            <div
              className={cx('swiperItem')}
              key={key}
              mechaid={item.mecha_id}
              onClick={e => {
                // store.onMechaPaginationClick(item.mecha_id);
              }}
            >
              <div className={'tabItemInner'}>
                <img className={'mechaImg'} src={item.mecha_tab_icon} alt={''} />
              </div>
            </div>
          );
        })}
      </BaseSwiper>
    );
  };

  return (
    <div className={styles.mechaTABSwiperBox}>
      {mechaTABSwiper()}
      <Link className={styles.prevBtn} onClick={store.moreMechaSwiper.goPrev} />
      <Link className={styles.nextBtn} onClick={store.moreMechaSwiper.goNext} />
    </div>
  );
};

export default wrapStore(MoreMecha, MoreMechaStore);
